/**
 * Catalogue of Inzichten articles. Used by the overview page,
 * sitemap fallbacks and "Lees ook" cards on related articles.
 */
export const ARTICLES = [
  {
    slug: "algoritmeregister-verplicht-gemeenten",
    to: "/inzichten/algoritmeregister-verplicht-gemeenten",
    category: "AI governance",
    title: "Is een algoritmeregister verplicht voor gemeenten?",
    summary:
      "Nog niet voor alle algoritmes verplicht, maar de richting is duidelijk. Wat gemeenten nu moeten regelen rond algoritmeregistratie, AVG en AI Act.",
    lastUpdated: "mei 2026",
  },
  {
    slug: "digitale-afhankelijkheid-overheid-cloud-act",
    to: "/inzichten/digitale-afhankelijkheid-overheid-cloud-act",
    category: "Digitale regie",
    title: "Digitale afhankelijkheid bij overheden: waarom dit bestuurlijk urgent wordt",
    summary:
      "Veel overheden zijn afhankelijk van Microsoft, AWS, Google en andere niet-Europese platforms. Wat dit betekent voor CLOUD Act, AI, data en digitale regie.",
    lastUpdated: "mei 2026",
  },
  {
    slug: "datalek-gemeente-onderwijs-avg-data-risicos",
    to: "/inzichten/datalek-gemeente-onderwijs-avg-data-risicos",
    category: "Datagovernance",
    title: "Datalek bij gemeente of onderwijsinstelling: AVG, AI en datarisico's",
    summary:
      "Datalekken bij gemeenten en onderwijsinstellingen tonen het belang van dataregie, AVG-naleving, AI-regels, leveranciersbeheer en incidentrespons.",
    lastUpdated: "mei 2026",
  },
  {
    slug: "ai-act-readiness-2026-mkb-adviesbureaus",
    to: "/inzichten/ai-act-readiness-2026-mkb-adviesbureaus",
    category: "AI Act readiness",
    title: "AI Act Readiness in 2026: wat MKB en adviesbureaus nú moeten regelen",
    summary:
      "Wat MKB-bedrijven, adviesbureaus en publieke organisaties in 2026 moeten regelen rond AI Act readiness, AI-governance, AI-registers en ChatGPT op het werk.",
    lastUpdated: "mei 2026",
  },
];

export function relatedFor(slug) {
  return ARTICLES.filter((a) => a.slug !== slug);
}
